import React from "react";
import "./MenuLayout.scss"
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";
const MenuLayout = ({ data, isMenu = false }) => {
    const dispatch = useDispatch()
    return (
        <div className="MenuLayout">
            <img alt="" src={data?.src} className="MenuLayout-image" />
            <div className="MenuLayout-container">
                <div className="MenuLayout-container-details">
                    <div className="MenuLayout-container-details-header">
                        {data?.title}
                    </div>
                    <div className="MenuLayout-container-details-des">
                        {data?.description}
                    </div>
                </div>
                {isMenu ? <div className="MenuLayout-container-btn"
                    onClick={() => {
                        if (data?.href && data?.href?.includes("https://")) {
                            window.open(data?.href, '_blank')
                        } else {
                            dispatch(setIsComing(true))
                        }
                    }}>
                    Order now
                </div> : <div className="MenuLayout-container-price">
                    {window.screen.width < 900 ? <span>----</span> : <span>---------------------</span>}
                    {data?.price}
                </div>}
            </div>
        </div>
    )
}
export default MenuLayout